import {useFormatCurrency, useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React, {useMemo} from 'react';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {Price} from '../../../types/Price';
import {Text} from '../../atoms/Text/Text';

interface DeliveryItemUnitPriceProps {
  unitPrice: Price;
  className?: string;
}

export const MultipleItemsUnitPrice: React.FC<DeliveryItemUnitPriceProps> = ({
  unitPrice,
  className,
}) => {
  const {t} = useTranslation();
  const formatCurrency = useFormatCurrency();

  const formattedUnitPrice = useMemo(
    () => formatCurrency(unitPrice.price.amount, unitPrice.price.currencyCode),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- formatCurrency is a stable function
    [unitPrice.price.amount, unitPrice.price.currencyCode],
  );

  return (
    <Wrapper data-testid="unitPriceBox" className={className}>
      <StyledLargeText data-testid="unitPrice">
        {t('{price} each', {price: formattedUnitPrice})}
      </StyledLargeText>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  text-align: left;
`;

const StyledLargeText = styled(Text)`
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  color: ${COLORS.strikePriceGrey};
  line-height: 1.5;
`;
